import React from 'react'
// import Header from '../Reusables/Header'
// import RBMTable from '../Tables/RBMTable'
import ABMselectionTable from '../Tables/ABMSelectionTable'
const ABMSelection = () => {
  return (
    <div className='home-screen' style={{padding:"20px"}}>
    <ABMselectionTable />
     {/* <RBMTable style={{marginTop:"20px",marginRight:"10px"}}/> */}
    </div>
  )
}

export default ABMSelection
